import type { Player } from '@swiss-magic/shared-types';

export function playerDisplayName(p: Player): string {
  return `${p.firstName} ${p.lastName}`.trim();
}

export function playerNameKey(firstName: string, lastName: string): string {
  return `${firstName.trim().toLowerCase()} ${lastName.trim().toLowerCase()}`;
}

export function getDuplicateKeys(players: Player[]): Set<string> {
  const counts = new Map<string, number>();
  for (const p of players) {
    const key = playerNameKey(p.firstName, p.lastName);
    counts.set(key, (counts.get(key) ?? 0) + 1);
  }
  const dupes = new Set<string>();
  for (const [key, count] of counts) {
    if (count > 1) dupes.add(key);
  }
  return dupes;
}
